module.exports = __webpack_public_path__ + "static/media/FCC_RWD.f6676e7e.png";